import { useState, useEffect, useRef } from 'react'
import { colors, fonts } from './UI'

export function hintsEnabled() {
  try { return localStorage.getItem('tic_hints_enabled') !== 'false' } catch { return true }
}

export default function Hint({ text, title }) {
  const [enabled, setEnabled] = useState(hintsEnabled)
  const [open, setOpen] = useState(false)
  const [tipStyle, setTipStyle] = useState({})
  const [arrowStyle, setArrowStyle] = useState({})
  const [showBelow, setShowBelow] = useState(false)
  const btnRef = useRef(null)
  const tooltipWidth = 240
  const tooltipHeight = 120 // estimated
  const margin = 12

  useEffect(() => {
    const handler = () => setEnabled(hintsEnabled())
    window.addEventListener('storage', handler)
    return () => window.removeEventListener('storage', handler)
  }, [])

  useEffect(() => {
    if (!open || !btnRef.current) return
    const rect = btnRef.current.getBoundingClientRect()
    const centreX = rect.left + rect.width / 2
    const halfTip = tooltipWidth / 2

    // Horizontal clamping
    let left = centreX - halfTip
    left = Math.max(margin, Math.min(left, window.innerWidth - tooltipWidth - margin))

    // Arrow offset relative to tooltip centre
    const arrowLeft = centreX - left

    // Vertical: prefer above, flip below if not enough room
    const spaceAbove = rect.top
    const spaceBelow = window.innerHeight - rect.bottom
    const below = spaceAbove < tooltipHeight + 20

    setShowBelow(below)
    setTipStyle({
      position: 'fixed',
      left: `${left}px`,
      ...(below ? { top: `${rect.bottom + 8}px` } : { top: `${rect.top - tooltipHeight - 8}px` }),
      zIndex: 1000,
      width: `${tooltipWidth}px`,
      background: colors.cardMid,
      border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: '12px',
      padding: '12px 14px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
    })
    setArrowStyle({
      position: 'absolute',
      left: `${Math.max(8, Math.min(arrowLeft, tooltipWidth - 8))}px`,
      transform: 'translateX(-50%) rotate(45deg)',
      width: '10px', height: '10px',
      background: colors.cardMid,
      border: '1px solid rgba(255,255,255,0.1)',
      ...(below
        ? { top: '-6px', borderBottom: 'none', borderRight: 'none' }
        : { bottom: '-6px', borderTop: 'none', borderLeft: 'none' }),
    })
  }, [open])

  if (!enabled) return null

  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <button
        ref={btnRef}
        onClick={e => { e.stopPropagation(); setOpen(o => !o) }}
        style={{ width: '18px', height: '18px', borderRadius: '50%', border: '1px solid rgba(${colors.textRgb},0.25)', background: `rgba(${colors.textRgb},0.06)`, color: `rgba(${colors.textRgb},0.6)`, cursor: 'pointer', fontSize: '10px', fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontFamily: fonts.body, flexShrink: 0, lineHeight: 1 }}
      >?</button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 999 }} />
          <div style={tipStyle}>
            {title && <div style={{ fontSize: '13px', fontWeight: 700, color: colors.gold, marginBottom: '6px' }}>{title}</div>}
            <div style={{ fontSize: '13px', fontWeight: 500, color: colors.muted, lineHeight: 1.6 }}>{text}</div>
            <div style={arrowStyle} />
          </div>
        </>
      )}
    </span>
  )
}
